module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7YzGK"))).then(() => parcelRequire('d0iPb'));